import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class Pavilion extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    let hObject = this
    this.registered = true

    var materialTapete = new BABYLON.StandardMaterial('tapete', window.scene)
    materialTapete.emissiveTexture = new BABYLON.Texture('static/textures/tapete.jpg', window.scene)

    materialTapete.emissiveTexture.uScale = 16.0
    materialTapete.emissiveTexture.vScale = 16.0

    var materialDomo = new BABYLON.StandardMaterial('domo', window.scene)
    materialDomo.emissiveTexture = new BABYLON.Texture('static/assets/Pavilion/pabellonCajasanX_Plane_009_EMIT.jpg', window.scene)

    materialDomo.emissiveTexture.uScale = 8.0
    materialDomo.emissiveTexture.vScale = 8.0

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/Pavilion/', 'pabellonCajasanX.babylon', window.scene, function (newMeshes, particleSystems) {
      // var i, j
      hObject.objectConfigurations(newMeshes)

      // tapete = newMeshes[0]

      newMeshes[3].material.backFaceCulling = false
      newMeshes[3].material.alpha = 0.7
      newMeshes[3].material = materialDomo

      newMeshes[2].material.backFaceCulling = false
      newMeshes[2].instances[0].material.backFaceCulling = false
      newMeshes[2].instances[1].material.backFaceCulling = false
      newMeshes[2].instances[2].material.backFaceCulling = false

      newMeshes[0].material = materialTapete
      newMeshes[1].material = materialDomo
      newMeshes[1].material.backFaceCulling = false
      newMeshes[1].material.alpha = 0.3
    })
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/Pavilion.js